import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
import { theme } from "../../Assets/Theme/theme";
import CustomButton from "../../Components/Common/CustomButton";
import { useNavigate } from "react-router-dom";

function UpcomingBookings({ data }) {
  const navigate = useNavigate();

  const initialData = [...(data || [])]
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .slice(0, 10);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2,
        }}
      >
        <Typography
          style={{ fontSize: "20px" }}
          fontWeight={700}
          color={theme.colors.text}
        >
          Upcoming Bookings
        </Typography>
        <Box>
          <CustomButton
            style={{ fontSize: "18px" }}
            onClick={() => navigate("/admin/booking")}
          >
            View all Bookings
          </CustomButton>
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 2,
          boxShadow: 0,
          border: "none",
          padding: 2,
        }}
      >
        <Table
          sx={{
            borderCollapse: "separate",
            borderSpacing: "0 15px",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                  fontSize: "16px",
                }}
              >
                S.No
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                  fontSize: "16px",
                }}
              >
                User Name
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                  fontSize: "16px",
                }}
              >
                User Type
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                  fontSize: "16px",
                }}
              >
                Experience
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                  fontSize: "16px",
                }}
              >
                No of people
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                  fontSize: "16px",
                }}
              >
                Date
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {initialData?.length ? (
              initialData.map((booking, index) => (
                <TableRow
                  key={booking.id || index}
                  sx={{
                    backgroundColor: theme.colors.lightGray,
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid #e0e0e0",
                    "& td": {
                      padding: "16px",
                      borderBottom: "none",
                    },
                  }}
                >
                  <TableCell>{index + 1}</TableCell> {/* S.No */}
                  <TableCell>{booking.userName}</TableCell>
                  <TableCell>{booking.userType}</TableCell>
                  <TableCell>{booking.destination}</TableCell>
                  <TableCell>{booking.participant}</TableCell>
                  <TableCell>{booking.date}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No bookings found
                </TableCell>
              </TableRow>
            )}

          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default UpcomingBookings;
